import { render, staticRenderFns } from "./LeagueOakNext.vue?vue&type=template&id=19b53574&scoped=true"
import script from "./LeagueOakNext.vue?vue&type=script&lang=js"
export * from "./LeagueOakNext.vue?vue&type=script&lang=js"
import style0 from "./LeagueOakNext.vue?vue&type=style&index=0&id=19b53574&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b53574",
  null
  
)

export default component.exports